import React from 'react';
import PropTypes from 'prop-types';

import HeaderAppTitle from "../../../../layout/top/header/common/app-title/app-title";

export default class NoteViewPageTitle extends React.Component {

    static propTypes = {
        revisionId: PropTypes.string,
        page: PropTypes.object,

        editable: PropTypes.bool,

        onChange: PropTypes.func,
    }

    onEditClick = () => {
        this.title.onEditClick()
    }

    onChange = (title) => {
        this.props.page.title = title
        this.props.onChange()
        this.forceUpdate()
    }

    render() {
        const pageTitleClasses = Classes("page-title", "max-w-600", {
            'in-revision': !!this.props.revisionId,
            'no-toolbar': !this.props.editable
        })

        return (
            <HeaderAppTitle ref         = {r=>this.title = r}
                            className   = {pageTitleClasses}
                            name        = {this.props.page.title}
                            editable    = {this.props.editable}
                            onChange    = {this.onChange} />
        );
    }
}